import React from "react";
import { useTranslation } from "react-i18next";
import {
    StyledLabel,
    StyledSelectInput,
    StyledTextInput,
} from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";

import { setCountryKeyValue, setIsEdited } from "../store";

import { CustomCardBody } from "@components/Common/CustomCardStyled";
import { ImageUploader } from "./ImageUploader";
import { languages } from "@constants/index";
import { languagesOptions, translatedLanguage } from "../hooks";

import "@assets/swal.css";
import "@assets/theme.css";
import "../index.css";
import "react-toastify/dist/ReactToastify.css";
import "react-languages-select/css/react-languages-select.css";

type LanguageBodyType = {
    tableState: any;
    languageFormState: any;
    setLanguageFormState: Function;
};
export default function LanguageBody({
    tableState,
    languageFormState,
    setLanguageFormState,
}: LanguageBodyType) {
    const { t } = useTranslation();
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const selectedLanguage: any = languages.find(
        (el: any) => el.value === i18nextLng
    );
    const changeLanguage = (value: any) => {
        setIsEdited(true);
        if (value === null && languageFormState.displayName === "") {
            setLanguageFormState((prev: any) => ({
                ...prev,
                langue: value !== null ? value.label : "",
                displayName: value !== null ? value.label : "",
                abbreviation: value !== null ? value.value : "",
                selectLangue: false,
                selectName: false,
                advancedDisplayName: {
                    languages: {
                        fr: "",
                        en: "",
                        nl: "",
                        es: "",
                        pt: "",
                        it: "",
                    },
                },
            }));
        } else if (value !== null) {
            setLanguageFormState((prev: any) => ({
                ...prev,
                langue: value !== null ? value.label : "",
                displayName: value !== null ? value.label : "",
                abbreviation: value !== null ? value.value : "",
                selectLangue: false,
                selectName: false,
                advancedDisplayName: {
                    ...prev.advancedDisplayName,
                    languages: translatedLanguage(t)[value?.label || ""],
                },
            }));
        }
    };

    const changeHandler = (value: any) => {
        setIsEdited(true);
        setCountryKeyValue(value !== null ? value.code : "");
        setLanguageFormState((prev: any) => ({
            ...prev,
            country: value !== null ? value : "",
            uploadedImage: "",
            countryKey: value !== null ? value.code : "",
            selectCountry: false,
            selectImage: false,
            isNotImg: false,
        }));
    };

    const setIsNotImg = (value: any) => {
        setLanguageFormState((prev: any) => ({
            ...prev,
            isNotImg: value,
        }));
    };

    const setUploadedImage = (value: any) => {
        setLanguageFormState((prev: any) => ({
            ...prev,
            uploadedImage: value,
        }));
    };

    const setSelectImage = (value: any) => {
        setLanguageFormState((prev: any) => ({
            ...prev,
            selectImage: value,
        }));
    };

    return (
        <CustomCardBody
            className={`pl-3 pr-5 `}
            style={{
                maxHeight: "470px",
                overflowY: " auto",
            }}
        >
            <AvGroup
                className={`${tableState.isConsult ? "pe-none__clz" : ""}`}
            >
                <StyledLabel htmlFor="text" className="required__clz mt-3">
                    {t("Language")}
                </StyledLabel>
                <StyledSelectInput
                    isClearable
                    value={
                        languageFormState.langue === ""
                            ? null
                            : {
                                  label: languageFormState.langue,
                                  value: languageFormState.langue,
                              }
                    }
                    className={classnames(
                        "lan_inp_FRlanguage",
                        {
                            invalid__clz:
                                languageFormState.selectLangue ||
                                languageFormState.isLanguageExist,
                        },
                        {
                            "not-allowed-input__clz":
                                tableState.rowData.Id !== undefined,
                        }
                    )}
                    onChange={(e: any) => {
                        changeLanguage(e);
                    }}
                    placeholder={t("Select")}
                    options={languagesOptions(t)}
                    validate={{
                        required: {
                            value: true,
                            errorMessage: `${t("Please select a language")!}`,
                        },
                    }}
                    name="mark"
                    noOptionsMessage={() => t("No options")}
                    autoFocus={tableState.rowData.Id === undefined}
                />
                {languageFormState.selectLangue ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please select a language")}
                    </div>
                ) : null}
                {languageFormState.isLanguageExist ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("the language already exists")}
                    </div>
                ) : null}
            </AvGroup>
            <AvGroup>
                <div className="d-flex justify-content-between mb-1">
                    <StyledLabel htmlFor="text" className="required__clz mt-3">
                        {t("Display name")}
                    </StyledLabel>
                    <span
                        style={{
                            color: "blue",
                            cursor: "pointer",
                            border: "transparent",
                            backgroundColor: "transparent",
                            textAlign: "center",
                            textDecoration: "underline",
                            font: "normal normal 600 16px/21px Segoe UI",
                            marginTop: "15px",
                        }}
                        role="button"
                        tabIndex={0}
                        onClick={(): void => {
                            setLanguageFormState((prev: any) => ({
                                ...prev,
                                isAdvancedDisplayNameModalOpen: !prev.isAdvancedDisplayNameModalOpen,
                            }));
                        }}
                        className={classnames("cmn_btn_advencedDisplayName", {
                            "not-allowed-icon__clz":
                                languageFormState.advancedDisplayName.languages[
                                    i18nextLng
                                ] === "" && languageFormState.langue === "",
                        })}
                    >
                        <span>{t("Advanced")}</span>
                    </span>
                </div>
                <StyledTextInput
                    className={classnames(
                        `${
                            tableState.isConsult ? "pe-none__clz " : ""
                        } lan_inp_FRdisplayName`,
                        {
                            input__clz: languageFormState.selectName,
                        }
                    )}
                    autocomplete="off"
                    name="designation"
                    onChange={(e: any) => {
                        setIsEdited(true);

                        if (
                            languageFormState.langue === "" &&
                            e.target.value === ""
                        ) {
                            setLanguageFormState((prev: any) => ({
                                ...prev,
                                displayName: e.target.value,
                                selectName: false,
                                advancedDisplayName: {
                                    languages: {
                                        fr: "",
                                        en: "",
                                        nl: "",
                                        es: "",
                                        pt: "",
                                        it: "",
                                    },
                                },
                            }));
                        } else {
                            setLanguageFormState((prev: any) => ({
                                ...prev,
                                displayName: e.target.value,
                                selectName: false,
                                advancedDisplayName: {
                                    ...prev.advancedDisplayName,
                                    languages: {
                                        ...prev.advancedDisplayName.languages,
                                        [selectedLanguage.value]:
                                            e.target.value,
                                    },
                                },
                            }));
                        }
                    }}
                    value={
                        languageFormState.advancedDisplayName.languages[
                            i18nextLng
                        ] ?? ""
                    }
                    placeholder={t("Write")}
                    type="text"
                />
                <div className="d-flex flex-wrap "></div>
                {languageFormState.selectName ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter a display name")}
                    </div>
                ) : null}
            </AvGroup>
            <AvGroup
                className={`${tableState.isConsult ? "pe-none__clz" : ""}`}
            >
                <StyledLabel htmlFor="text" className="required__clz mt-3">
                    {t("Country")}
                </StyledLabel>

                <StyledSelectInput
                    isClearable
                    value={
                        languageFormState.country === ""
                            ? null
                            : languageFormState.country
                    }
                    className={classnames("lan_inp_FRcountry", {
                        invalid__clz: languageFormState.selectCountry,
                    })}
                    placeholder={t("Select")}
                    onChange={(e: any) => {
                        changeHandler(e);
                    }}
                    options={languageFormState.countryOptions}
                    validate={{
                        required: {
                            value: true,
                            errorMessage: `${t("Please select a country")!}`,
                        },
                    }}
                    name="country"
                    noOptionsMessage={() => t("No options")}
                />
                {languageFormState.selectCountry ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please select a country")}
                    </div>
                ) : null}
            </AvGroup>
            <AvGroup
                className={`${tableState.isConsult ? "pe-none__clz" : ""}`}
            >
                <StyledLabel htmlFor="text" className="required__clz mt-3">
                    {t("Flag")}
                </StyledLabel>
                <span style={{ fontSize: "15px", marginLeft: "3px" }}>
                    ({t("Insert an image such as PNG, JPG or JPEG")})
                </span>
                <ImageUploader
                    setIsNotImg={setIsNotImg}
                    uploadedImage={languageFormState.uploadedImage}
                    setUploadedImage={setUploadedImage}
                    setIsEdited={setIsEdited}
                    setSelectImage={setSelectImage}
                    borderColor={languageFormState.borderColor}
                    countryKey={languageFormState.countryKey}
                />
                {languageFormState.isNotImg && (
                    <div
                        style={{
                            width: "100%",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please insert a PNG, JPG or JPEG image.")}
                    </div>
                )}
                {languageFormState.selectImage && (
                    <div
                        style={{
                            width: "100%",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please insert a flag.")}
                    </div>
                )}
            </AvGroup>
        </CustomCardBody>
    );
}
